import { FaSearch, FaHome, FaArrowLeft } from "react-icons/fa";

const NotFound = () => {
  const goBack = () => {
    window.history.back();
  };

  const goHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="flex justify-center items-center min-h-screen" style={{ backgroundColor: 'var(--background-color)', zIndex: 10 }}>
      <div className="w-4/5 max-w-2xl bg-var(--background-color) border border-var(--border-color) rounded-2xl p-12 text-center relative overflow-hidden shadow-2xl">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-2 bg-red-500"></div>
        <div className="absolute top-4 right-4 w-16 h-16 bg-red-500 rounded-full opacity-20"></div>
        <div className="absolute bottom-4 left-4 w-12 h-12 bg-red-500 rounded-full opacity-15"></div>
        
        {/* 404 Icon */}
        <div className="relative z-10 mb-8">
          <div className="w-24 h-24 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
            <FaSearch className="text-white text-4xl" />
          </div>
        </div>

        {/* Content */}
        <div className="relative z-10">
          <h2 className="text-6xl font-bold text-var(--text-color) mb-4">404</h2>
          <h3 className="text-2xl font-semibold text-var(--text-color) mb-6">Page Not Found</h3>
          <p className="text-lg text-var(--text-color) opacity-80 mb-8 leading-relaxed">
            The page you're looking for doesn't exist or has been moved. 
            Please check the URL or navigate to a different page.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button 
              onClick={goBack}
              className="bg-red-500 hover:bg-red-600 text-white font-bold px-6 py-3 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center text-lg group"
            >
              <FaArrowLeft className="mr-2 group-hover:-translate-x-1 transition-transform" />
              Go Back
            </button>
            <button 
              onClick={goHome}
              className="bg-[#FC532B] hover:bg-[#e04a26] text-white font-bold px-6 py-3 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center text-lg group"
            >
              <FaHome className="mr-2 group-hover:rotate-12 transition-transform" />
              Go Home
            </button>
          </div>

          {/* Additional Info */}
          <div className="mt-8 p-4 bg-var(--background-color) border border-var(--border-color) rounded-lg">
            <p className="text-sm text-var(--text-color) opacity-70">
              If you believe this is an error, please contact our support team.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
